module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"station-donggang":"Donggang","station-liuqiu":"Liuqiu","from-station":"From","destination-station":"Destination"},"zh-TW":{"station-donggang":"東港","station-liuqiu":"小琉球","from-station":"去程","destination-station":"回程"}}')
  delete Component.options._Ctor
}
